export const Products = {
  PAID_MARKETING: 'PaidMarketing',
  BOT_ZAPPING: 'BotZapping',
} as const
